var app = angular.module('directives.paymentCheck');

app.directive('paymentCheck', [
    'configs',
    '$state',
    function(configs, $state) {
        var tmplUrl;
        var lustState = $state.current.name.replace('pages.','');

        try {
            tmplUrl = require('../templates/'+$state.current.name.replace('pages.','')+'.html');//looking for template with moduleName
        }catch(e){
            tmplUrl = require('../templates/index.html')//if error, use default template
        }

        var parsedLink = $state.current.url.split("/");
        parsedLink.forEach(function(key) {
            if (key == 'l') {
                tmplUrl = require('../templates/index.html');
            }
            if (key == 'ls') {
                tmplUrl = require('../templates/service.html');
            }
        });

        return {
            template: tmplUrl,
            controller:'checkCtrl',
            link: function(scope, element, attrs, ctrl) {
                if (lustState && $state.current.name.replace('pages.','') == 'payment' && lustState !== $state.current.name.replace('pages.','')) {
                    lustState = $state.current.name.replace('pages.','');
                    setTimeout(function () {
                        window.location.reload();
                    }, 100)
                    // window.location.href = window.location.href;
                } else if (!lustState) {
                    lustState = $state.current.name.replace('pages.','');
                }
            }
        }

    }
]);

app.controller('checkCtrl', function ($rootScope, $scope, Pay) {
    $scope.pay = Pay;

    $scope.yasnoNextStep = function () {
        var division = $scope.pay.fields.find(function (field) {
            return field.alias === 'DIVISIONS'
        });

        if(division) {
            var account = $scope.pay.fields.find(function (field) {
                return field.alias === 'key_id_m'
            });

            if(division.value && account && account.value) {
                $scope.pay.checkPayment();
            }
        } else {
            $scope.pay.checkPayment();
        }
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentCheck/directives/paymentCheck.js
 ** module id = 193
 ** module chunks = 1
 **/